import React, { useMemo, useCallback } from 'react'
import { useShoppingCartContext } from '../../providers/ShoppingCartProvider'
import Warning from './Types/Warning'

const CartDataHasChanged = () => {
  const {
    setIsCartDataMerged,
  } = useShoppingCartContext()
  const style = useMemo(
    () => ({ fontSize: '16px' }),
    [],
  )

  const handleNotificationOnHide = useCallback(
    () => {
      setIsCartDataMerged(false)
    },
    [setIsCartDataMerged],
  )

  const message = (
    <span style={style}>
      <b>Important!</b>
      {' '}
      Your Cart has been updated based on your previous shopping activities.
    </span>
  )

  return (
    <Warning
      id="cartMergedNotif"
      message={message}
      timeout={30000}
      cb={handleNotificationOnHide}
    />
  )
}

export default CartDataHasChanged
